import React from "react";
import { PropTypes } from "prop-types";
import { Box } from "@mui/material";

const OrderingList = ({ listItems, renderOrderField, renderText }) => {
  return (
    <Box display="flex" flexDirection="column">
      {listItems &&
        listItems.map((listItem, index) => (
          <Box display="flex" key={index} mb={2.5}>
            {renderOrderField && (
              <Box mr={2} display="flex" alignItems="center" height={56}>
                {renderOrderField(listItem, index)}
              </Box>
            )}
            {renderText(listItem, index)}
          </Box>
        ))}
    </Box>
  );
};

export default OrderingList;

OrderingList.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      text: PropTypes.string
    })
  ),
  renderText: PropTypes.func,
  renderOrderField: PropTypes.func
};
